import { useAIFeatureEnableManager } from "@/src/hooks/AIFeatureEnableManager"
import { setSRPFloatingAIChatEnabled } from "@/src/redux/slices/aiFeatureSlice"
import { useAppDispatch } from "@/src/redux/store"
import { AutoAwesome } from "@mui/icons-material"
import { Box, ButtonBase, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import { useCallback } from "react"

export const ToggleSRPFloatingAIChatMobile = () => {
    const t = useTranslations('common')

    const { srpSmartFilterSort } = useAIFeatureEnableManager()
    const dispatch = useAppDispatch()
    const onAiFilterClick = useCallback(() => {
        dispatch(setSRPFloatingAIChatEnabled(
            {
                enabled: true,
                enableOnboardingPopUp: true
            }
        ))
    }, [dispatch])

    if (!srpSmartFilterSort) return null

    return (
        <ButtonBase
            onClick={onAiFilterClick}
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 1.5,
                height: '100%'
            }}
        >
            <Box sx={{
                position: 'relative',
                display: 'inline-flex',
                '& .sparkle': {
                    animation: 'aiSpin 2.4s linear infinite'
                },
                '@keyframes aiSpin': {
                    '0%': { transform: 'rotate(0deg) scale(1)' },
                    '50%': { transform: 'rotate(180deg) scale(1.05)' },
                    '100%': { transform: 'rotate(360deg) scale(1)' }
                }
            }}> <AutoAwesome className="sparkle" fontSize="small" color='primary' /> </Box>
            <Typography variant="caption" sx={{ fontWeight: 500, mt: 0.5 }}>
                {t('aiMode')}
            </Typography>
        </ButtonBase>
    )
}
